import { render, staticRenderFns } from "./RememberPasswordView.vue?vue&type=template&id=389d1a6c&scoped=true&lang=pug"
import script from "./RememberPasswordView.vue?vue&type=script&lang=ts"
export * from "./RememberPasswordView.vue?vue&type=script&lang=ts"
import style0 from "./RememberPasswordView.vue?vue&type=style&index=0&id=389d1a6c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d1a6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('389d1a6c')) {
      api.createRecord('389d1a6c', component.options)
    } else {
      api.reload('389d1a6c', component.options)
    }
    module.hot.accept("./RememberPasswordView.vue?vue&type=template&id=389d1a6c&scoped=true&lang=pug", function () {
      api.rerender('389d1a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RememberPassword/RememberPasswordView.vue"
export default component.exports